import { Box, Grid, Paper, Typography } from '@mui/material';
import LocationMap from '../LocationMap';

import PhonelinkRingIcon from '@mui/icons-material/PhonelinkRing';
import PhoneIcon from '@mui/icons-material/Phone';
import FaxIcon from '@mui/icons-material/Fax';

import SocialButtons from '../../components/SocialButtons';

export default function HomeContact() {
    return (
        <Paper align='center' elevation={5} sx={{  padding: 3 , borderRadius: "16px", mt: 4}} container spacing={2}>
            <Typography
                component="h1"
                variant="h4"
                paddingTop={'15px'}
                sx={{  fontWeight: 'bold' }}
                >
                ติดต่อเรา
                </Typography>
                <Grid container spacing={3.5} sx={{ mt: 1 }}>

                {/* LEFT SIDE */}
                <Grid item xs={12} md={8}>
                    
                    <LocationMap />
                    
                    
                </Grid>
                {/* RIGHT SIDE */}
                <Grid item xs={12} md={4} align='center'  sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    
                    <Typography component="h1" variant="body1" align='center' paddingTop={'15px'}>
                    24, 26, 28 ถนนพุทธมณฑลสาย 3 <br />
                    แขวงหนองค้างพลู เขตหนองแขม กรุงเทพฯ 10160 <br />
                    <a
                        href="https://maps.app.goo.gl/4fLPDyRZXHn9fPHGA?g_st=il"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#1976d2", textDecoration: "underline" }}
                    >
                        View on Google Maps
                    </a>
                    <br />
                    <div style={{ textAlign: 'left', display: 'inline-block', paddingBottom: 15, paddingTop: 15 }}>
                        <PhoneIcon fontSize='small'/>: (02) 408 9488-9 <br />
                        <FaxIcon fontSize='small'/>: (02) 408 9490 <br />
                        <PhonelinkRingIcon fontSize='small'/>: (086) 366 0298 - นัท<br />
                        <PhonelinkRingIcon fontSize='small'/>: (098) 935 5858 - นน<br />
                    </div>
                    <br />
                    Email: hopbon1999@gmail.com <br />
                    
                    <br />
                    
                    </Typography>
                    <Box >
                        <SocialButtons />
                    </Box>
                    
                </Grid>
                </Grid>
            </Paper>
    );
}
